module.exports = __webpack_public_path__ + "img/mobility-points.26b28c05.svg";